import { render, staticRenderFns } from "./mapping.vue?vue&type=template&id=09ff7a54"
import script from "./mapping.vue?vue&type=script&lang=ts"
export * from "./mapping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports